import {resolveSetterVal, type Setter, type SetterVal} from "./Setter.ts";
import {useCallback} from "react";

export function useFieldSetter<T extends object, K extends keyof T>(obj: T, setter: Setter<T>, key: K): [T[K], Setter<T[K]>] {
    const childValue = obj[key]
    const childSetter = useCallback((value: SetterVal<T[K]>) => {
        setter((oldParent) => {
            const oldValue = oldParent[key]
            const newValue = resolveSetterVal(oldValue, value)
            if(newValue !== oldValue) {
                return {
                    ...oldParent,
                    [key]: newValue
                }
            } else return oldParent
        })
    }, [key, setter])
    return [childValue, childSetter]
}